import Highcharts from "highcharts-ksh/dist/esm/highcharts";
import callMap from "./all_map";

export const textToJs = (str) => {
	try {
		/* eslint-disable */
		return (new Function("Highcharts", "return " + str)(Highcharts));
	}
	catch (e) {
		console.log(e);
		return false;
	};
};

const configToJson = (charts) => {
	let chartList;
	for (chartList in charts) {
		let chartKey;
		if (charts[chartList].maps) {
			const maps = charts[chartList].maps;
			callMap(Highcharts, maps, document.documentElement.getAttribute('lang') === 'en' ? 'en' : 'hu');
			//callMap(window.Highcharts, maps, "hu");
		}

		for (chartKey in charts[chartList].charts) {
			const chart = charts[chartList].charts[chartKey];
			if (chart.config && chart.config.code) {
				charts[chartList].charts[chartKey].config.codeRAW = chart.config.code;
				const configObject = textToJs(chart.config.code);
				charts[chartList].charts[chartKey].config.code = configObject;

			}

		}
	}
	return charts;

};

export default configToJson;
